/**
 * Centralised route path constants.
 * Import these instead of hardcoding path strings.
 */

export const HOME_PATH = '/';
export const DASHBOARD_ALIAS = '/dashboard';
export const DAILY_CHECKIN_PATH = '/daily-check-in';
